import { _mock } from "./_mock";
import { APPLICATION_PAYMENT_STATUS_OPTIONS } from "src/utils/applicationConstants";
import {
  PASSES_NAMES,
  TICKETS_NAMES,
  types,
  PROVIDER_NAMES,
} from "./_passestickets";
// ----------------------------------------------------------------------
export const _userpasses = [...Array(12)].map((_, index) => {
  const type = types[0];
  const name = PASSES_NAMES[index % 4];

  const status = index % 2 ? false : true;

  return {
    id: Math.floor(Math.random() * 1000),
    providerName: PROVIDER_NAMES[index % 4],
    name: name,
    status: status,
    createdAt: _mock.time(index),
    periodStart: _mock.time(index),
    periodEnd: _mock.time(index),
    actualCredit: Math.floor(Math.random() * 10 + 1),
    startCredit: 10,
    price: 100,
    currency: "HUF",
    paymentType: Math.floor(Math.random() * 3) + 1,
    type: type,
    paymentStatus:
      APPLICATION_PAYMENT_STATUS_OPTIONS[Math.floor(Math.random() * 3)],
  };
});

export const _usertickets = [...Array(12)].map((_, index) => {
  const type = types[1];
  const name = TICKETS_NAMES[index % 4];

  const status = index % 2 ? false : true;

  return {
    id: Math.floor(Math.random() * 1000),
    providerName: PROVIDER_NAMES[index % 4],
    name: name,
    status: status,
    createdAt: _mock.time(index),
    periodStart: _mock.time(index),
    periodEnd: _mock.time(index),
    actualCredit: Math.floor(Math.random() * 10 + 1),
    startCredit: 10,
    price: 100,
    currency: "HUF",
    paymentType: Math.floor(Math.random() * 3) + 1,
    type: type,
    paymentStatus:
      APPLICATION_PAYMENT_STATUS_OPTIONS[Math.floor(Math.random() * 3)],
  };
});
